export class Position {
    constructor(
        public readonly x: number,
        public readonly y: number
    ) {}
} 